/**
 * 新元素提示管理器
 */
let NewIntroManager = xClass("NewIntroManager")

const CONFIG_PATH = "meta/intro.json";
const CONFIG_PATH_B = "meta/introB.json";

/**
 * 类型枚举
 */
const ContentType = {
    kMode: 1,
    kEle: 2,
    kIsland: 3
}

/**
 * 显示优先级
 */
const PriorityMap = {
    [ContentType.kMode]: 2,    
    [ContentType.kEle]: 1,
    [ContentType.kIsland]: 0
}

/**
 * 文本提示
 */
const DescMap = {
    [ContentType.kMode]: "home.small.target.new.mode",    
    [ContentType.kEle]: "home.small.target.new.element",
    [ContentType.kIsland]: "home.small.target.new.island"
} 

let _instance = null;
NewIntroManager.getInstance = function() {
    if (_instance == null)
        _instance = NewIntroManager.create();
    return _instance
}

NewIntroManager.prototype.ctor = function() {
    this.array = null;
    this.cache = {};
}

/**
 * 加载资源
 */
NewIntroManager.prototype.load = function() {
    if (this.array != null)
        return Promise.resolve();

    let configPath = UserManager.getInstance().isLevelTestGroup() ? CONFIG_PATH_B : CONFIG_PATH
    return new Promise((resolve, reject)=> {
        ResManager.load(configPath)
            .then(data=> {
                this.array = $tableToArray(data[0][0]);
                ResManager.release([configPath]);
                resolve();
            })
            .catch(reject)
    });
}

/**
 * 获取下一个新内容
 * 当多个内容同时符合条件时，优先级大的优先显示 优先级为 关卡模式 > 元素 > 新岛屿
 * @param levelId 当前主线关卡
 * @param maxLevel 当前可游戏的最大主线关卡
 */
NewIntroManager.prototype.getNewIntro = function (levelId, maxLevel) {
    if (UserManager.getInstance().reachTopLevel()) {
        return {
            // desc: getText("home.small.target.reachlimit"),
            desc: getText(""),//有神秘岛去掉提示
            name: ""
        };
    }
    let lastItem = null;
    for (let i = 0; i < this.array.length; i++) {
        let item = this.array[i];

        if (item.level <= maxLevel && item.minLevel <= levelId && item.level > levelId) {
            if (item["desc"] == null)
                item["desc"] = getText(DescMap[item.type], {levelId: item.level});
            
            if (lastItem == null) {
                lastItem = item;
                continue;
            } else {
                if (item.minLevel > lastItem.minLevel) 
                    return lastItem;
                else if(PriorityMap[item.type] > PriorityMap[lastItem.type])
                    return item;
                else
                    continue;
            }
        } else if (lastItem != null) {
            return lastItem;
        }
    }
    
    return lastItem;
}
/**
 * 获取岛屿所出现的新元素
 */
NewIntroManager.prototype.getIslandNewIntro = function (id) {
    let islandConfigs = UserManager.getInstance().getIslandsConfig();
    let islandMsg = null;
    for (let i = 0; i < islandConfigs.length; i++) {
        if (islandConfigs[i] && islandConfigs[i].id == id){
            islandMsg = islandConfigs[i];
        }
    }
    let newIntroArr = [];
    if (!islandMsg) return newIntroArr;
    let minLevel = islandMsg.minLevel + 1
    let maxLevel = islandMsg.maxLevel
    cc.log("[IslandBook] NewIntroManager getIslandNewIntro islandMsg ",islandMsg);
    for (let i = 0; i < this.array.length; i++) {
        let item = this.array[i];
        if (item.level >= minLevel && item.level <= maxLevel && item.type == ContentType.kEle){
            newIntroArr.push(item);
        }
    }
    cc.log("[IslandBook] NewIntroManager getIslandNewIntro newIntroArr ",newIntroArr);
    return newIntroArr;

}

NewIntroManager.ContentType = ContentType
module.exports = NewIntroManager